import { OuiValidationError } from 'omnium-ui/form-field';

export function siretErrors(): OuiValidationError[] {
  return [
    { code: 'minlength', message: 'Le SIRET doit faire 14 chiffres (trop court)' },
    { code: 'maxlength', message: 'Le SIRET doit faire 14 chiffres (trop long)' },
  ];
}
